export default __webpack_public_path__ + "static/media/a017-line1.3313726a.svg";